import { useEffect, useState } from "react";
import DashboardCard from "../../../components/DashboardCard";
import { useHistory } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../Login/selectors/permissionSelector";
import { PresentationChartLineIcon } from "@heroicons/react/24/solid";
import { PERMISSIONS } from "../../PermissionsConstants";
import { getDigitalAssetCount } from "modules/CarrierAgreementMgmt/DigitalAsset/api/getDigitalAssetCount";
const NewDigitalAssetsCard = () => {
  const modulePermission =
    PERMISSIONS.permission_carrieragreemnentmgmt_digitalassets_view;
  const userPermissions = useRecoilValue(permissionsSelector);

  const history = useHistory();

  const [digitalAssets, setDigitalAssets] = useState<number | string>("...");

  useEffect(() => {
    getDigitalAssetCount()
      .then(setDigitalAssets)
      .catch((error) => {
        console.error("Failed to fetch digital asset count:", error);
        setDigitalAssets(0);
      });
  }, []);

  return (
    <div
      className="p-2 pr-4 bg-white text-primary rounded-lg animate-fade-in-down2 shadow-md hover:text-white hover:bg-secondary"
      onClick={() => {
        if (userPermissions.includes(modulePermission)) {
          const urlPath = "/officesettings/digitalassets";
          history.push({
            pathname: urlPath,
            state: "officeKey",
          });
        }
      }}
    >
      <DashboardCard
        text="Digital Assets"
        count={digitalAssets}
        image={
          <PresentationChartLineIcon className="text-white bg-secondary rounded-md h-7 w-7 p-1" />
        }
        hasAccess={userPermissions.includes(modulePermission)}
      />
    </div>
  );
};

export default NewDigitalAssetsCard;
